<form>
  <mat-form-field *ngIf="users$ | async; let users" class="form-whole-line">
    <mat-select [formControl]="resultControl" [placeholder]="placeholderText">
      <mat-option>
        <ngx-mat-select-search [formControl]="userFilter"
                               noEntriesFoundLabel="{{'user-selector.no-entries' | translate}}"
                               placeholderLabel="{{'user-selector.placeholder' | translate}}"></ngx-mat-select-search>
      </mat-option>
      <mat-option [value]="null"><span>{{ noUser }}</span></mat-option>
      <mat-option *ngFor="let user of users | callbackFilter: userFilter.value: filter" [value]="user.id">
        {{user.surname}}, {{user.givenName}} ({{user?.email | lowercase}})
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
